import { module } from './store'

export const cartExtend = {
  key: 'cart',
  store: { modules: [{ key: 'cart', module }] },
}

